// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__szxtx","large":"styles_large__2IhTY"};